import { render, staticRenderFns } from "./preview-file-upload-answer-sheet-dialog.vue?vue&type=template&id=9b38288c&scoped=true"
import script from "./preview-file-upload-answer-sheet-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./preview-file-upload-answer-sheet-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./preview-file-upload-answer-sheet-dialog.vue?vue&type=style&index=0&id=9b38288c&prod&scoped=true&lang=css"
import style1 from "./preview-file-upload-answer-sheet-dialog.vue?vue&type=style&index=1&id=9b38288c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b38288c",
  null
  
)

export default component.exports